export enum DealType {
  PRIMARY = "primary",
  BUY = "buy",
  RENT = "rent",
}
